import { render, staticRenderFns } from "./BuilderText.vue?vue&type=template&id=07119ec1&"
import script from "./BuilderText.vue?vue&type=script&lang=js&"
export * from "./BuilderText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports